import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Payment(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Payment", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.dark,
        d: "M27.75 26.25c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.secondary.main,
        d: "M28.5 13.5v-3A1.5 1.5 0 0 1 30 12a.75.75 0 1 0 1.5 0 3 3 0 0 0-3-3v-.75a.75.75 0 1 0-1.5 0V9a3 3 0 0 0 0 6v3a1.5 1.5 0 0 1-1.5-1.5.75.75 0 1 0-1.5 0 3 3 0 0 0 3 3v.75a.75.75 0 1 0 1.5 0v-.75a3 3 0 0 0 0-6Zm-3-1.5a1.5 1.5 0 0 1 1.5-1.5v3a1.5 1.5 0 0 1-1.5-1.5Zm3 6v-3a1.5 1.5 0 1 1 0 3Zm15.027 6.832a3.075 3.075 0 0 0-2.575.548l-9.975 7.735a7.495 7.495 0 0 1-3.227 1.438V32.31a2.925 2.925 0 0 0-2.175-2.798l-5.37-1.485a7.752 7.752 0 0 0-5.655.608L6 33.233V43.5l7.841-1.52h14.783a7.5 7.5 0 0 0 5.142-2.04l11.123-10.476a2.707 2.707 0 0 0-1.362-4.631Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.light,
        d: "M27.75 33.03v1.521a7.665 7.665 0 0 1-1.38.12c-.463 0-.924-.037-1.38-.112l-5.625-.967a.754.754 0 1 1 .255-1.486l5.624.968c.83.143 1.68.128 2.506-.045Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.light,
        d: "m2.25 45.75 6-.61a1.59 1.59 0 0 0 1.5-1.612L9.098 32.21a1.666 1.666 0 0 0-2.093-1.413L2.25 31.884V45.75Z"
      }
    )
  ] });
}
Payment.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Payment"
};
validateTidalLicense();
export {
  Payment
};
//# sourceMappingURL=Payment.js.map
